import { Controller } from "stimulus";
const OPTIONS = {
  threshold: .5
}

export default class extends Controller {
  connect() {
    this.animateElements = document.querySelectorAll('.animate');
    this.initAnimation();
  }

  initAnimation() {
    if ("IntersectionObserver" in window) {
      let animateElObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            let animateEl = entry.target;
            animateEl.classList.add('is-visible');
            animateElObserver.unobserve(animateEl);
          }
        });
      }, OPTIONS);

      this.animateElements.forEach(function(animateEl) {
        animateElObserver.observe(animateEl);
      });

    } else {
      // Fallback for IE 11
      this.animationFallback();
      document.addEventListener('scroll', this.animationFallback());
    }
  }

  animationFallback() {
    var animateElements = [].slice.call(document.querySelectorAll('.animate'));
    animateElements.forEach(function(animateEl) {
      if (animateEl.getBoundingClientRect().top <= window.innerHeight && animateEl.getBoundingClientRect().bottom >= 0) {
         animateEl.classList.add('is-visible');
      }
    });
  }

}